import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'

export const participatingPhysicianBuyingGroupsContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
          "fields": {
            "name": "Participating Physician Buying Groups",
            "title": "Participating Physician Buying Groups",
            "slug": "participating-physician-buying-groups",
            "content": {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "Dx2mrzerHr6nXy0JiYrXl",
                "type": "Entry",
                "createdAt": "2024-03-20T20:36:54.264Z",
                "updatedAt": "2024-03-20T20:36:54.264Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 6,
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "richTextContentPageTemplate"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "name": "Participating Physician Buying Groups > Content",
                "modules": [
                  {
                    "metadata": {
                      "tags": [],
                      "concepts": []
                    },
                    "sys": {
                      "space": {
                        "sys": {
                          "type": "Link",
                          "linkType": "Space",
                          "id": "n9bebhw263o0"
                        }
                      },
                      "id": "2HkECAnVEWoNzkeV8Rn1eT",
                      "type": "Entry",
                      "createdAt": "2024-03-20T20:36:54.288Z",
                      "updatedAt": "2024-03-20T20:36:54.288Z",
                      "environment": {
                        "sys": {
                          "id": "sandbox",
                          "type": "Link",
                          "linkType": "Environment"
                        }
                      },
                      "publishedVersion": 7,
                      "revision": 1,
                      "contentType": {
                        "sys": {
                          "type": "Link",
                          "linkType": "ContentType",
                          "id": "bannerComponent"
                        }
                      },
                      "locale": "en-US"
                    },
                    "fields": {
                      "title": "Participating Physician Buying Groups > Content > Banner",
                      "headline": "Participating Physician Buying Groups",
                      "backgroundImage": {
                        "metadata": {
                          "tags": [],
                          "concepts": []
                        },
                        "sys": {
                          "space": {
                            "sys": {
                              "type": "Link",
                              "linkType": "Space",
                              "id": "n9bebhw263o0"
                            }
                          },
                          "id": "1Px4l8fvDKjBGrRTCqfWrE",
                          "type": "Asset",
                          "createdAt": "2022-12-29T16:44:45.722Z",
                          "updatedAt": "2022-12-29T16:44:45.722Z",
                          "environment": {
                            "sys": {
                              "id": "sandbox",
                              "type": "Link",
                              "linkType": "Environment"
                            }
                          },
                          "publishedVersion": 5,
                          "revision": 1,
                          "locale": "en-US"
                        },
                        "fields": {
                          "title": "Banner BG strand top right",
                          "description": "Banner BG strand top right",
                          "file": {
                            "url": bannerStrand,
                            "details": {
                              "size": 47693,
                              "image": {
                                "width": 1920,
                                "height": 511
                              }
                            },
                            "fileName": "Banner_BG_strand_right.png",
                            "contentType": "image/png"
                          }
                        }
                      },
                      "country": {
                        "metadata": {
                          "tags": [],
                          "concepts": []
                        },
                        "sys": {
                          "space": {
                            "sys": {
                              "type": "Link",
                              "linkType": "Space",
                              "id": "n9bebhw263o0"
                            }
                          },
                          "id": "7iOWBmppZrkK5s40UUIzOV",
                          "type": "Entry",
                          "createdAt": "2023-09-28T22:24:03.948Z",
                          "updatedAt": "2023-09-28T22:24:03.948Z",
                          "environment": {
                            "sys": {
                              "id": "sandbox",
                              "type": "Link",
                              "linkType": "Environment"
                            }
                          },
                          "publishedVersion": 3,
                          "revision": 1,
                          "contentType": {
                            "sys": {
                              "type": "Link",
                              "linkType": "ContentType",
                              "id": "country"
                            }
                          },
                          "locale": "en-US"
                        },
                        "fields": {
                          "name": "United States",
                          "isocode": "US",
                          "flag": {
                            "metadata": {
                              "tags": [],
                              "concepts": []
                            },
                            "sys": {
                              "space": {
                                "sys": {
                                  "type": "Link",
                                  "linkType": "Space",
                                  "id": "n9bebhw263o0"
                                }
                              },
                              "id": "3aYCbZJiL8aoEKRdhjOXyy",
                              "type": "Asset",
                              "createdAt": "2023-05-24T22:54:50.939Z",
                              "updatedAt": "2023-05-24T22:54:50.939Z",
                              "environment": {
                                "sys": {
                                  "id": "sandbox",
                                  "type": "Link",
                                  "linkType": "Environment"
                                }
                              },
                              "publishedVersion": 5,
                              "revision": 1,
                              "locale": "en-US"
                            },
                            "fields": {
                              "title": "usa flag",
                              "description": "USA Flag",
                              "file": {
                                "url": usaFlag,
                                "details": {
                                  "size": 2487,
                                  "image": {
                                    "width": 36,
                                    "height": 26
                                  }
                                },
                                "fileName": "usa_flag.svg",
                                "contentType": "image/svg+xml"
                              }
                            }
                          },
                          "locales": [
                            "en-US"
                          ]
                        }
                      }
                    }
                  },
                  {
                    "metadata": {
                      "tags": [],
                      "concepts": []
                    },
                    "sys": {
                      "space": {
                        "sys": {
                          "type": "Link",
                          "linkType": "Space",
                          "id": "n9bebhw263o0"
                        }
                      },
                      "id": "6zxWFY2UVBxUNASwUcNl8e",
                      "type": "Entry",
                      "createdAt": "2024-03-20T20:36:54.412Z",
                      "updatedAt": "2024-07-02T15:56:48.750Z",
                      "environment": {
                        "sys": {
                          "id": "sandbox",
                          "type": "Link",
                          "linkType": "Environment"
                        }
                      },
                      "publishedVersion": 79,
                      "revision": 10,
                      "contentType": {
                        "sys": {
                          "type": "Link",
                          "linkType": "ContentType",
                          "id": "richTextContentComponent"
                        }
                      },
                      "locale": "en-US"
                    },
                    "fields": {
                      "title": "Participating Physician Buying Groups > Content > Rich Text",
                      "content": {
                        "nodeType": "document",
                        "data": {},
                        "content": [
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "By making our products accessible through trusted physician buying groups (PBGs), Moderna aims to support healthcare providers in delivering the best possible care to their patients.",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "Please note that while Moderna strives to make its products available through a network of trusted PBGs, we do not have direct control over the specific contracts or arrangements between PBGs and their member physicians.",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://abcpbg.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Abacus  ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n844-987-4687 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.accessvaccines.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Access Vaccines ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n866-318-6850 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.atlantichealthpartners.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Atlantic Health Partners ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n800-741-2044 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.childrenshospitals.org/childhealthadvantage"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Child Health Advantage (Children’s Hospital Association) ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n913-981-4214 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.cwpurchasing.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "CommonWealth Purchasing Group ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n833-274-0313  ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.cppdocs.org"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "CPP (Children’s Practicing Pediatricians) ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n877-277-9330 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://mainstreetvacs.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Main Street Vaccines ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n888-482-6246  ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://mppg.net"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Medical Practice Purchasing Group (MPPG) ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n818-332-7057 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.nationalpurchasinggroup.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "National Purchasing Group ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n615-390-0702 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.nationalphysiciancare.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "NDC NPC ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n877-598-3286 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://pediatric-alliance.com/"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Pediatric Alliance ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n804-310-3068 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://physiciansalliance.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Physician’s Alliance of America ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n866-348-9780 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://prn-gpo.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Physicians Resource Network (PRN) ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n888-PRN-2360 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.primarycarealliance.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Primary Care Alliance ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n801-369-3933 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.practicewell.org"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Physicians’ Buying Group",
                                    "marks": [
                                      {
                                        "type": "bold"
                                      }
                                    ],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n415-963-4444 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.updoctors.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "United Physicians ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n248-593-0100 ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://usppg.org"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "USPPG ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n877-MY-USPPG ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://www.vacconnect.com"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Vaccine Connect ",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": "\n843-973-2711  ",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          },
                          {
                            "nodeType": "paragraph",
                            "data": {},
                            "content": [
                              {
                                "nodeType": "text",
                                "value": "For more information, please contact your preferred PBG or our ",
                                "marks": [],
                                "data": {}
                              },
                              {
                                "nodeType": "hyperlink",
                                "data": {
                                  "uri": "https://modernadirect.com/contact-us"
                                },
                                "content": [
                                  {
                                    "nodeType": "text",
                                    "value": "Customer Care Team",
                                    "marks": [],
                                    "data": {}
                                  }
                                ]
                              },
                              {
                                "nodeType": "text",
                                "value": ".",
                                "marks": [],
                                "data": {}
                              }
                            ]
                          }
                        ]
                      },
                      "printButtonLabel": "Print",
                      "country": "[Circular Reference]"
                    }
                  }
                ]
              }
            }
          },
          "sys": {
            "id": "3UcXz1k6IagTbGFKogiM5w",
            "type": "Entry"
          }
        }
      ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}